import { Supertype, Remoteable, Persistable, Bindable } from "@haventech/amorphic";

/**
 * @deprecated Please see Confluence page "Don't use amorphic types"
 */
export class IsomorphicPersistent extends Persistable(Remoteable(Supertype)) {}

/**
 * @deprecated Please see Confluence page "Don't use amorphic types"
 */
export class Persistent extends Persistable(Supertype) {}

/**
 * @deprecated Please see Confluence page "Don't use amorphic types"
 */
export class IsomorphicQuery extends Remoteable(Persistable(Supertype)) {}

/**
 * @deprecated Please see Confluence page "Don't use amorphic types"
 */
export class Query extends Persistable(Supertype) {}

/**
 * @deprecated Please see Confluence page "Don't use amorphic types"
 */
export class Isomorphic extends Remoteable(Supertype) {}

/**
 * @deprecated Please see Confluence page "Don't use amorphic types"
 */
export class Serializable extends Supertype {}

/**
 * @deprecated Please see Confluence page "Don't use amorphic types"
 */
export class AppController extends Remoteable(Bindable(Supertype)) {}

/**
 * @deprecated Please see Confluence page "Don't use amorphic types"
 */
export class SubController extends Remoteable(Supertype) {}

/**
 * @deprecated Please see Confluence page "Don't use amorphic types"
 */
export class Everything extends Persistable(Remoteable(Bindable(Supertype))) {}